import { useQuery } from '@tanstack/react-query';

import { matchKeys } from '@/hooks/matches/matchKeys';
import { getMatchup } from '@/infrastructure/network/data/matchups/matchup';

export const useMatchesQuery = (matchId: string) => {
	return useQuery({
		queryKey: matchKeys.matches(matchId),
		queryFn: () => getMatchup({ matchupId: matchId })
	});
};
